function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.3 0H3.842a2.7 2.7 0 00-2.655 2.214l-1.143 6.3A2.7 2.7 0 002.7 11.701h4.104L6.3 12.988A3.717 3.717 0 009.801 18a.9.9 0 00.819-.531l2.565-5.77H15.3A2.7 2.7 0 0018 9V2.7A2.7 2.7 0 0015.3 0zm-3.6 10.612L9.252 16.12a1.917 1.917 0 01-1.242-2.502l.477-1.287A1.8 1.8 0 006.803 9.9H2.7a.9.9 0 01-.693-.325.9.9 0 01-.207-.738l1.143-6.3a.9.9 0 01.9-.738H11.7v8.812zM16.2 9a.9.9 0 01-.9.9h-1.8V1.8h1.8a.9.9 0 01.9.9V9z",
  fill: "currentColor",
  fillRule: "evenodd"
})));